import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ToolbarButton, createSlotFill } from '@wordpress/components';
import { cog as cogIcon } from '@wordpress/icons';
const { Slot, Fill } = createSlotFill('HeaderToolbar');
const Header = ({ toggleSidebar, sidebarOpen }) => {
    return (_jsxs("div", Object.assign({ className: "block-editor__header", role: "region" }, { children: [_jsx(Slot, { className: "block-editor__header-toolbar", bubblesVirtually: true }), _jsx(ToolbarButton, { onClick: toggleSidebar, isPressed: sidebarOpen, icon: cogIcon, label: 'Settings' })] })));
};
Header.Fill = Fill;
export default Header;
//# sourceMappingURL=Header.js.map